import { useContext, useEffect, useState } from 'react';

import { getWalletFromCommonCheckoutApi } from '../../../services/commonCheckout/getWalletFromCommonCheckoutApi';
import { AppContext } from '../../contextStore/AppContext';
import type { PaymentMethodType } from '../../../services/customer/types';
import type { FormattedPaymentMethod } from '../../checkout/components/Wallet/types';
import { formatPaymentMethods } from '../../checkout/components/Wallet/utils';
import useShowAddPaymentMethodWarning from '../../../shared/hooks/add-payment-method/useShowAddPaymentMethodWarning';

const useWalletManagementComponentData = () => {
  const { customerId, setData, isPrimaryRouteInFocus } =
    useContext(AppContext);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [formattedPaymentMethods, setFormattedPaymentMethods] =
    useState<FormattedPaymentMethod<PaymentMethodType>[]>([]);

  useShowAddPaymentMethodWarning();

  const hideLoader = () => {
    setIsLoading(false);
    setData({ overlayLoaderConfig: { show: false } });
  };

  useEffect(() => {
    if (!customerId) {
      return;
    }

    setIsLoading(true);
    setData({ overlayLoaderConfig: { show: true } });

    (async () => {
      const { paymentMethods: paymentMethodsFromResponse } =
        await getWalletFromCommonCheckoutApi({
          customerId,
        });

      setFormattedPaymentMethods(
        formatPaymentMethods(paymentMethodsFromResponse),
      );

      setData({ paymentMethods: paymentMethodsFromResponse });

      hideLoader();
    })().catch(() => {
      hideLoader();
    });
  }, [isPrimaryRouteInFocus]);

  return {
    isLoading,
    formattedPaymentMethods,
  };
};

export default useWalletManagementComponentData;
